import React from 'react';
import './Success.css';

const Cancel = () => {

    return (
        <div className='success'>
            <div className="voxy-success">VACE.AI</div>
            <div className='b-success'>
                <b>Cancelled</b>
            </div>
            <div className='ai-success'>
                Your purchase is cancelled. 
            </div>
        </div>
    );
};

export default Cancel;